<mat-form-field appearance="outline" class="w-full">
  <mat-label>{{ to.label }}</mat-label>
  <input matInput [matAutocomplete]="auto" [formControl]="$any(formControl)" [formlyAttributes]="field">
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="getLabel.bind(this)">
    @for (item of filter | async; track item) {
      <mat-option [value]="item.value">
        {{ item.label }}
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
